import { useEffect } from 'preact/hooks';

import WebApp from '@twa-dev/sdk';

export function useVerticalSwipeEffect(enabled: boolean) {
  useEffect(() => {
    if (enabled) {
      WebApp.enableVerticalSwipes();
    } else {
      WebApp.disableVerticalSwipes();
    }

    return () => {
      WebApp.disableVerticalSwipes();
    };
  }, [enabled]);
}
